<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 4.5a4.127 4.127 0 0 1 4.043 3.322l.225 1.125 1.147.083a2.235 2.235 0 0 1 2.085 2.22 2.257 2.257 0 0 1-2.25 2.25H4.5a3 3 0 0 1-3-3 2.98 2.98 0 0 1 2.67-2.978l.803-.082.375-.713A4.102 4.102 0 0 1 9 4.5ZM9 3a5.622 5.622 0 0 0-4.987 3.03A4.496 4.496 0 0 0 0 10.5C0 12.982 2.018 15 4.5 15h9.75c2.07 0 3.75-1.68 3.75-3.75a3.732 3.732 0 0 0-3.488-3.72A5.617 5.617 0 0 0 9 3Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
